import { env } from 'src/env.mjs';

const countries = {
    AU: 'Australia',
    NZ: 'New Zealand',
};

export const countryCodes = {
    AU: 'AU',
    NZ: 'NZ',
} as const;

export type CountryType = (typeof countries)[keyof typeof countries];
export type CountryCode = keyof typeof countries;
export default countries;

export function isCountry(countryCode: CountryCode): boolean {
    return env.NEXT_PUBLIC_COUNTRY_CODE === countryCode;
}

export const displayCountry: string = countries[env.NEXT_PUBLIC_COUNTRY_CODE];
